import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { format, isValid } from 'date-fns';

@Pipe({ name: 'baseFormatTime' })
@Injectable({ providedIn: 'root' })
export class BaseFormatTimePipe implements PipeTransform {
  transform(value: string | undefined | null, label?: string): string {
    if (!value) {
      return '';
    }

    return value && isValid(new Date(value))
      ? !!label
        ? `${format(new Date(value), 'HH:mm')} ${label}`
        : format(new Date(value), 'HH:mm')
      : value;
  }
}
